module.exports = __webpack_public_path__ + "img/english_play_store.5a39280c.png";